import request from '@/utils/request'

export function orderDetail (id) {
    return request({
        url: 'order/detail',
        method: 'GET',
        params: {orderId: id}
    })
}

export function orderPayStatus (data) {
    return request({
        url: 'order/pay_status',
        method: 'GET',
        params: data
    })
}

export function orderDetailSn (data) {
    return request({
        url: 'order/detailsn',
        method: 'GET',
        params: data
    })
}

export function orderList (data) {
    return request({
        url: 'order/list',
        method: 'GET',
        params: data
    })
}

export function orderSubmit (data) {
    // 备注 message;
    //  consignee;
    //  mobile;
    //  province;
    //  city;
    //  region;
    //  province_code;
    //  city_code;
    //  region_code;
    //  postcode;
    //  address;
    return request({
        url: 'order/submit',
        method: 'POST',
        params: data
    })
}